import React, {useState} from "react";
import {
  FormGroup,
} from "components/common";
import { Trans } from "react-i18next";
import { Button, Col, Row, Modal, ModalBody, ModalFooter, ModalHeader, Input } from "reactstrap";
import Select from "react-select";

export const ManageFeatures = ({
  t,
  item,
  featuresList,
  show,
  setisOpen,
  updateFeaturesList,
}) => {

  const [confirmAddNew, addNew] = useState(false);

  const handleClose = () => {
    setisOpen(false)
    addNew(false)
  }

const iconList = [
    {value: "fa fa-check-circle", label:t("Checked")},
    {value: "fa fa-times-circle", label:t("Unchecked")},
    {value: "fa fa-user-plus", label:t("User")},
    {value: "fa fa-lock", label:t("Lock")},
    {value: "fa fa-unlock", label:t("Unlock")},
    {value: "fa fa-unlink", label:t("Unlink")},
    {value: "fa fa-download", label:t("Download")},
    {value: "fa fa-save", label:t("Save")},
  ]

  const [newFeature, setNewFeature] = useState({ icon: '', name: '' });

  const handleAddFeature = () => {
    if (!newFeature.icon || !newFeature.name) return;
    const updatedList = [...featuresList, newFeature];
    updateFeaturesList(updatedList);
    setNewFeature({ icon: '', name: '' });
    if (featuresList.length > 8) {
        addNew(false)
    }
  };

  const handleRemoveFeature = (index) => {
    const updatedList = featuresList.filter((_, i) => i !== index);
    updateFeaturesList(updatedList);
  };

  return (
    <Modal isOpen={show} toggle={handleClose}>
        <ModalHeader closeButton>Add/Remove Subscription Features</ModalHeader>
        <ModalBody style={{ overflowY: 'visible', paddingTop: 0,  }}>
        <div>
        {featuresList.length > 0 ? (
            <table className="table table-sm border compact-table">
                <thead>
                    <tr>
                    <th><Trans>Icon</Trans></th>
                    <th className="text-left"><Trans>Feature Name</Trans></th>
                    <th className="text-right"><Trans>Remove</Trans></th>
                    </tr>
                </thead>
                <tbody>
                    {featuresList?.map((i, index) => (
                    <tr key={i.name}>
                        <td><i className={i.icon} /></td>
                        <td className="text-left">{i.name}</td>
                        <td className="text-right">
                        <button className="btn btn-danger btn-sm" onClick={() => handleRemoveFeature(index)}>
                            <span className="fa fa-minus" style={{ fontSize: 15, marginTop: '0.15em' }}></span>
                        </button>
                        </td>
                    </tr>
                    ))}
                </tbody>
            </table>
            ) : (
                <div className="mb-2 alert alert-warning text-center"><Trans>{item?.name} does not have any features</Trans></div>
            )}
            {featuresList.length > 9 ? 
                <div className="mb-2 alert alert-warning text-center"><Trans>Maximum Features Added. Cannot Add More</Trans></div>
                :
                <>{!confirmAddNew && <Button color="primary" className="my-2 mx-0 w-100" onClick={() => addNew(true)}><span className="fa fa-plus mr-1" /><Trans>Add New Line</Trans></Button>}</>
            }
                {confirmAddNew && (
                    <Row className="align-items-center d-flex">
                        <Col md="4">
                        <FormGroup>
                          <Select
                            style={{ backgroundColor: '#F4F7FE' }}
                            value={newFeature.icon}
                            onChange={(selectedOption) => setNewFeature({ ...newFeature, icon: selectedOption.value })}
                            options={iconList}
                            clearable={false}
                          />
                        </FormGroup>
                        </Col>
                        <Col md="4">
                        <FormGroup>
                            <Input
                            type="text"
                            placeholder="Feature Name"
                            value={newFeature.name}
                            onChange={(e) => setNewFeature({ ...newFeature, name: e.target.value })}
                            />
                        </FormGroup>
                        </Col>
                        <Button size="sm" color="danger" onClick={() => addNew(false)}><Trans>Cancel</Trans></Button>
                        <Button size="sm" color="primary" onClick={handleAddFeature}><Trans>Add</Trans></Button>
                    </Row>
                    )}
    </div>
        </ModalBody>
        <ModalFooter>
        <Button color="secondary" onClick={handleClose}><Trans>Close</Trans></Button>
        </ModalFooter>
    </Modal>

  );
};


export default ManageFeatures;
